<template>
  <div class="layer background" ref="bg" :small="small" >
    <div class="layer" :time="time">
      <div class="layer layer0 day" ref="day0"></div>
      <div class="layer layer0 day-rain" ref="day0r"></div>
      <div class="layer layer0 day-rain-clouds" ref="day0rc"></div>
      <div class="layer layer0 day-storm" ref="day0s"></div>
      <div class="layer layer0 day-storm-clouds" ref="day0sc"></div>
      <div class="layer layer0 night" ref="night0"></div>
      <div class="layer layer0 night-rain" ref="night0r"></div>
      <div class="layer layer0 night-rain-clouds" ref="night0rc"></div>
      <div class="layer layer0 night-storm" ref="night0s"></div>
      <div class="layer layer0 night-storm-clouds" ref="night0sc"></div>
      <div class="layer layer1 day"></div>
      <div class="layer layer1 night" ref="night1"></div>
      <div class="layer layer2 day"></div>
      <div class="layer layer2 night" ref="night2"></div>
      <div class="layer layer2 baloons" >
        <div class="chat-baloon" v-for="(item, idx) in baloons"  v-show="item.layer==2 && simulation.data.currentTime>0" :id="'baloon-'+idx" :key="idx" :type="item.type" :status="item.status" :style="{marginLeft:(-50+item.left)+'%',bottom:item.bottom}">
          <span v-if="item.type=='happy'"><img src="@/assets/img/bubble-happy.svg" ></span>
          <span v-if="item.type=='mad'"><img src="@/assets/img/bubble-angry.svg" ></span>
          <span v-if="item.type=='normal'"><img src="@/assets/img/bubble-ok.svg" ></span>
          <span v-if="item.type=='thumbsup'"><img src="@/assets/img/bubble-thumbsup.svg" ></span>
          <span v-if="item.type=='thumbsdown'"><img src="@/assets/img/bubble-thumbsdown.svg" ></span>
          <span v-if="item.type=='confused'"><img src="@/assets/img/bubble-confused.svg" ></span>
          <span v-if="item.type=='heart'"><img src="@/assets/img/bubble-heart.svg" ></span>
        </div>
      </div>
      <div class="layer layer3 day"></div>
      <div class="layer layer3 night" ref="night3"></div>
      <div class="layer layer3 baloons" >
        <div class="chat-baloon" v-for="(item, idx) in baloons" v-show="item.layer==3 && simulation.data.currentTime>0" :id="'baloon-'+idx" :key="idx" :type="item.type" :status="item.status" :style="{marginLeft:(-50+item.left)+'%',bottom:item.bottom}">
          <span v-if="item.type=='happy'"><img src="@/assets/img/bubble-happy.svg" ></span>
          <span v-if="item.type=='mad'"><img src="@/assets/img/bubble-angry.svg" ></span>
          <span v-if="item.type=='normal'"><img src="@/assets/img/bubble-ok.svg" ></span>
          <span v-if="item.type=='thumbsup'"><img src="@/assets/img/bubble-thumbsup.svg" ></span>
          <span v-if="item.type=='thumbsdown'"><img src="@/assets/img/bubble-thumbsdown.svg" ></span>
          <span v-if="item.type=='confused'"><img src="@/assets/img/bubble-confused.svg" ></span>
          <span v-if="item.type=='heart'"><img src="@/assets/img/bubble-heart.svg" ></span>
        </div>
      </div>
      <div id="water-tower-bg"></div>
      <div id="town-house-baloon"></div>
      <div class="layer layer4 day-rain-weather" ref="day0rw"></div>
      <div class="layer layer4 night-rain-weather" ref="night0rw"></div>
      <div class="layer layer4 day-storm-weather" ref="day0sw"></div>
      <div class="layer layer4 night-storm-weather" ref="night0sw"></div>
    </div>
  </div>
</template>

<script>
import simulation from '@/lib/simulation.js'

const items = [
  {
    type: 'happy',
    status: 'visible',
    left: 19,
    bottom: '12vw',
    layer: 3
  },
  {
    type: 'normal',
    status: 'visible',
    left: 21,
    bottom: '17vw',
    layer: 3
  },
  {
    type: 'happy',
    status: 'visible',
    left: 18,
    bottom: '20vw',
    layer: 3
  },
  {
    type: 'normal',
    status: 'visible',
    left: 17,
    bottom: '28vw',
    layer: 2
  },
  {
    type: 'happy',
    status: 'visible',
    left: 20,
    bottom: '26vw',
    layer: 2
  },
  {
    type: 'normal',
    status: 'visible',
    left: 32,
    bottom: '21vw',
    layer: 2
  },
  {
    type: 'happy',
    status: 'visible',
    left: 38,
    bottom: '24vw',
    layer: 2
  }
]

export default {
  name: 'background',
  data: function () {
    return {
      currentPump: 0,
      baloons: items,
      simulation: simulation,
      events: {
        sunrise: 3600 * 6,
        night: 3600 * 20,
        rain: [],
        storm: []
      }
    }
  },
  mounted: function () {
    const self = this
    this.currentPump = this.pump
    this.setupEvents()
    this.stopMonitor()
    clearInterval(window.backgroundMonitor)
    window.backgroundMonitor = setInterval(this.monitorView.bind(this), 500)
    const moveBackground = function (px, py) {
    }
    setInterval(function () {
      const pos = Math.round(Math.sin(simulation.data.currentTime / 3600) * 10) / 10
      moveBackground(pos * 2, -pos * 2)
    }, 500)
    this.baloonChange()
    window.addEventListener('resize', function () {
      self.resize()
    })
    self.resize()
  },
  props: {
    pump: Object,
    small: Boolean,
    time: {
      type: String,
      default: ''
    }
  },
  methods: {
    resize: function () {
      const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
      const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
      const ratio = vw / vh * 10
      if (!this.$refs.bg) {
        return
      }
      this.$refs.bg.setAttribute('offset', '0')
      if (ratio > 22) {
        this.$refs.bg.setAttribute('offset', '1')
      }
      if (ratio > 28) {
        this.$refs.bg.setAttribute('offset', '2')
      }
    },
    setupEvents: function () {
      if (this.currentPump) {
        for (const idx in this.currentPump.events) {
          const ev = this.currentPump.events[idx]
          if (ev.type === 'sunrise') {
            this.events.sunrise = ev.position
          }
          if (ev.type === 'night') {
            this.events.night = ev.position
          }
          if (ev.type === 'rain') {
            this.events.rain.push({
              start: ev.position,
              end: ev.position + ev.duration,
              drops: true
            })
          }
          if (ev.type === 'rain') {
            this.events.rain.push({
              start: ev.position,
              end: ev.position + ev.duration,
              drops: true
            })
          }
          if (ev.type === 'cloudy') {
            this.events.rain.push({
              start: ev.position,
              end: ev.position + ev.duration,
              drops: false
            })
          }
          if (ev.type === 'storm') {
            this.events.storm.push({
              start: ev.position,
              end: ev.position + ev.duration
            })
          }
        }
      }
    },
    baloonChange: function () {
      clearTimeout(this.baloonProc)
      if (simulation.running) {
        for (const idx in this.baloons) {
          const baloon = this.baloons[idx]
          const normal = ['none', 'normal', 'happy', 'thumbsup', 'heart']
          const mad1 = ['none', 'mad', 'normal', 'confused', 'thumbsdown']
          const mad2 = ['mad', 'mad', 'thumbsdown']
          let type = 'none'
          let fixed = false
          if (simulation.data.currentLevel === 0 || simulation.data.currentLevel === 100) {
            type = mad2[Math.floor(Math.random() * mad2.length)]
            if (mad2.indexOf(baloon.type) === -1 && baloon.type !== 'none') {
              baloon.type = 'none'
              fixed = true
            }
          } else if (simulation.data.currentLevel < 10 || simulation.data.currentLevel > 90) {
            type = mad1[Math.floor(Math.random() * mad1.length)]
            if (mad1.indexOf(baloon.type) === -1) {
              baloon.type = 'none'
              fixed = true
            }
          } else {
            type = normal[Math.floor(Math.random() * normal.length)]
            if (normal.indexOf(baloon.type) === -1) {
              baloon.type = 'none'
              fixed = true
            }
          }
          if (Math.random() < 0.5 && !fixed) {
            if (baloon.type === 'none') {
              baloon.type = type
            } else {
              baloon.type = 'none'
            }
          }
        }
      }
      window.baloonProc = setTimeout(this.baloonChange.bind(this), 2000)
    },
    monitorView: function () {
      if (this.currentPump) {
        this.updateView()
      }
    },
    stopMonitor: function () {
      clearTimeout(window.baloonProc)
      clearInterval(window.backgroundMonitor)
    },
    updateView: function () {
      const day0 = this.$refs.day0
      if (!day0) {
        this.stopMonitor()
        return
      }
      let dayOp = 1
      let nightOp = 0
      const sunrise = this.events.sunrise
      const afterSunrise = sunrise - 1800
      const night = this.events.night
      const afterNight = night - 1800
      let isDay = true
      // day/night events
      if (this.currentPump && this.currentPump.currentTime < sunrise) {
        isDay = false
      }
      if (this.currentPump && this.currentPump.currentTime < afterSunrise) {
        dayOp = 0
        nightOp = 1
      } else if (this.currentPump && this.currentPump.currentTime < sunrise) {
        const diff = ((this.currentPump.currentTime - afterSunrise) / (sunrise - afterSunrise))
        dayOp = diff
        nightOp = 1 - diff
      } else if (this.currentPump && this.currentPump.currentTime > night) {
        dayOp = 0
        nightOp = 1
      } else if (this.currentPump && this.currentPump.currentTime > afterNight) {
        const diff = ((night - this.currentPump.currentTime) / (night - afterNight))
        dayOp = diff
        nightOp = 1 - diff
      } else {
        dayOp = 1
        nightOp = 0
      }
      this.$refs.day0.style.opacity = dayOp
      this.$refs.night0.style.opacity = nightOp
      this.$refs.night1.style.opacity = nightOp
      this.$refs.night2.style.opacity = nightOp
      this.$refs.night3.style.opacity = nightOp
      // rain event
      this.$refs.day0r.style.opacity = 0
      this.$refs.day0rc.style.opacity = 0
      this.$refs.day0rw.style.opacity = 0
      this.$refs.night0r.style.opacity = 0
      this.$refs.night0rc.style.opacity = 0
      this.$refs.night0rw.style.opacity = 0
      for (const idx in this.events.rain) {
        const rain = this.events.rain[idx].start
        const drops = this.events.rain[idx].drops
        const endRain = this.events.rain[idx].end
        if (this.currentPump && this.currentPump.currentTime >= rain && this.currentPump.currentTime <= endRain) {
          let rainOp = 1
          if (this.currentPump.currentTime - rain < 600) {
            rainOp = ((this.currentPump.currentTime - rain) / 600)
          }
          if (endRain - this.currentPump.currentTime < 600) {
            rainOp = ((endRain - this.currentPump.currentTime) / 600)
          }
          if (isDay) {
            this.$refs.day0r.style.opacity = rainOp
            this.$refs.day0rc.style.opacity = rainOp
            if (drops) {
              this.$refs.day0rw.style.opacity = rainOp
            }
          } else {
            this.$refs.night0r.style.opacity = rainOp
            this.$refs.night0rc.style.opacity = rainOp
            if (drops) {
              this.$refs.night0rw.style.opacity = rainOp
            }
          }
        }
      }
      // storm event
      this.$refs.day0s.style.opacity = 0
      this.$refs.day0sc.style.opacity = 0
      this.$refs.day0sw.style.opacity = 0
      this.$refs.night0s.style.opacity = 0
      this.$refs.night0sc.style.opacity = 0
      this.$refs.night0sw.style.opacity = 0
      for (const idx in this.events.storm) {
        const storm = this.events.storm[idx].start
        const endStorm = this.events.storm[idx].end
        if (this.currentPump && this.currentPump.currentTime >= storm && this.currentPump.currentTime <= endStorm) {
          let stormOp = 1
          if (this.currentPump.currentTime - storm < 600) {
            stormOp = ((this.currentPump.currentTime - storm) / 600)
          }
          if (endStorm - this.currentPump.currentTime < 600) {
            stormOp = ((endStorm - this.currentPump.currentTime) / 600)
          }
          if (isDay) {
            this.$refs.day0s.style.opacity = stormOp
            this.$refs.day0sc.style.opacity = stormOp
            this.$refs.day0sw.style.opacity = stormOp
          } else {
            this.$refs.night0s.style.opacity = stormOp
            this.$refs.night0sc.style.opacity = stormOp
            this.$refs.night0sw.style.opacity = stormOp
          }
        }
      }
    }
  },
  watch: {
    pump: function (newValue) {
      this.currentPump = newValue
      this.setupEvents()
      this.updateView()
    }
  }
}
</script>

<style scoped lang="scss">
.background {
  transition: opacity linear .3s;
  overflow: hidden;
}
.layer{
  background-repeat: no-repeat;
  background-size: cover;
  background-position: left center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  --transition: background-position linear .2s;
  &[time='day']{
    .night{
      display: none;
    }
  }
}
.layer0.day{
  background-image: url('../assets/img/backgrounds/Day-Clear-BG.svg');
}
.layer0.day-rain{
  background-image: url('../assets/img/backgrounds/Day-Rain-BG.svg');
  opacity: 0;
}
.layer0.day-rain-clouds{
  background-image: url('../assets/img/backgrounds/Day-Rain-Clouds.svg');
  opacity: 0;
}
.layer0.day-storm{
  background-image: url('../assets/img/backgrounds/Day-Storm-BG.svg');
  opacity: 0;
}
.layer0.day-storm-clouds{
  background-image: url('../assets/img/backgrounds/Day-Storm-Clouds.svg');
  opacity: 0;
}
.layer1.day{
  background-image: url('../assets/img/backgrounds/Day-Core-3.svg');
}
.layer2.day{
  background-image: url('../assets/img/backgrounds/Day-Core-2.svg');
}
.layer3.day{
  background-image: url('../assets/img/backgrounds/Day-Core-1.svg');
}
.layer0.night{
  background-image: url('../assets/img/backgrounds/Night-Clear-BG.svg');
}
.layer0.night-rain{
  background-image: url('../assets/img/backgrounds/Night-Rain-BG.svg');
  opacity: 0;
}
.layer0.night-rain-clouds{
  background-image: url('../assets/img/backgrounds/Night-Rain-Clouds.svg');
  opacity: 0;
}
.layer0.night-storm{
  background-image: url('../assets/img/backgrounds/Night-Storm-BG.svg');
  opacity: 0;
}
.layer0.night-storm-clouds{
  background-image: url('../assets/img/backgrounds/Night-Storm-Clouds.svg');
  opacity: 0;
}
.layer1{
  background-position: center 30%;
  background-size:100vw;
}
.layer2{
  background-position: left bottom;
  background-size:100vw;
}
.layer3{
  background-position: left bottom;
  background-size:100vw;
}
.layer4{
  background-position: center center;
}
.layer1.night{
  background-image: url('../assets/img/backgrounds/Night-Core-3.svg');
}
.layer2.night{
  background-image: url('../assets/img/backgrounds/Night-Core-2.svg');
}
.layer3.night{
  background-image: url('../assets/img/backgrounds/Night-Core-1.svg');
}
.layer4.day-rain-weather{
  background-image: url('../assets/img/backgrounds/Day-Rain-WeatherEffects.svg');
  opacity: 0;
}
.layer4.night-rain-weather{
  background-image: url('../assets/img/backgrounds/Night-Rain-WeatherEffects.svg');
  opacity: 0;
}
.layer4.day-storm-weather{
  background-image: url('../assets/img/backgrounds/Day-Storm-WeatherEffects.svg');
  opacity: 0;
}
.layer4.night-storm-weather{
  background-image: url('../assets/img/backgrounds/Night-Storm-WeatherEffects.svg');
  opacity: 0;
}
#water-tower-bg{
  height: 10%;
  width: 10%;
  top: 60%;
  left: 4%;
  position:absolute;
}
#town-house-baloon{
  height: 5%;
  width: 18%;
  top: 72%;
  left: 12%;
  position:absolute;
}
.chat-baloon{
  width: 45px;
  height: 45px;
  --background-color: #fff;
  --border-radius: 16px;
  position: absolute;
  border: 0;
  --box-shadow: 0px 0px 4px 2px rgba(192,192,192,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: margin-left linear .2s, margin-top linear .2s, opacity linear .2s, transform linear .3s;
  opacity: 1;
  transform: scale(1);
  transform-origin: 50% 100% 0;
  left: 50%;
  bottom: 50%;
  &[type='none']{
    opacity: 0;
    transform: scale(0);
  }
  > span {
    font-size: 24px;
  }
}
.layer2{
  .chat-baloon{
    img {
      width: 60px;
      height: 60px;
    }
  }
}
.background[offset='1'] .layer{
    height: 105%;
    &.layer1{
      background-position: left 60%;
    }
}
.background[offset='2'] .layer{
    height: 108%;
    &.layer1{
      background-position: left 60%;
    }
}
.background[small='true']{
  .layer{
    background-position: center center !important;
    background-size: cover !important;
  }
  .layer1{
    background-position: center 10vw !important;
  }
  .layer2{
    background-position: 20% 10vw !important;
  }
  .layer3{
    background-position: 20% 10vw !important;
  }
  .night{
    display:none;
  }
}
.challenge[number='0'] .chat-baloon{
  display: none;
}
@media (max-height: 800px){
  .layer2{
    background-position: -3vw bottom;
    background-size: 103vw;
    .chat-baloon{
      transform: translate(-2vw,-1vw)
    }
  }
  .layer3{
    background-position: -5vw bottom;
    background-size: 105vw;
    .chat-baloon{
      transform: translate(-4vw,-1vw)
    }
  }
}
@media only screen and (max-device-height: 670px) {
  .chat-baloon{
    display:none;
  }
}
@media (max-width: 1023px) {
  .chat-baloon{
    display:none;
  }
}
</style>
